<template>
    <Page type="gray" :nopadding="true">
        <template v-slot:body>
            <TransferDetail />
        </template>
    </Page>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import Page from            '@/components/sides/Page.vue' 
import TransferDetail from  '@/components/personal/transfer/Detail.vue' 

export default {
    components: {
        Page,
        TransferDetail
    },
    data() {
        return {
 
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screen_size() { return this.$store.getters.StateScreenSize },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    methods: {
        
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
    },
}
</script>